// react
import React from "react"
import { connect } from "react-redux"
import DocumentTitle from "react-document-title"
// material-ui
import { Step, Stepper, StepButton } from "material-ui/Stepper"
// app
import Step1 from "./Step1"
import Step2 from "./Step2"
import Step3 from "./Step3"
import Step4 from "./Step4"
import Step5 from "./Step5"
import Step6 from "./Step6"
import Step7 from "./Step7"
import Step8 from "./Step8"

import * as types from "components/person/types"


const initialState = {
    stepIndex: 0
}

class Profile extends React.Component {
    constructor(props) {
        super()

        this.state = initialState

        this.step1 = () => this.setState({ stepIndex: 0 })
        this.step2 = () => this.setState({ stepIndex: 1 })
        this.step3 = () => this.setState({ stepIndex: 2 })
        this.step4 = () => this.setState({ stepIndex: 3 })
        this.step5 = () => this.setState({ stepIndex: 4 })
        this.step6 = () => this.setState({ stepIndex: 5 })
        this.step7 = () => this.setState({ stepIndex: 6 })
        this.step8 = () => this.setState({ stepIndex: 7 })
    }

    getActiveStepComponent() {
        const personid = this.props.params.personid // react-router injected

        switch (this.state.stepIndex) {
            case 1: return <Step2 personid={ personid } />
            case 2: return <Step3 personid={ personid } />
            case 3: return <Step4 personid={ personid } />
            case 4: return <Step5 personid={ personid } />
            case 5: return <Step6 personid={ personid } />
            case 6: return <Step7 personid={ personid } />
            case 7: return <Step8 personid={ personid } />
            default: return <Step1 personid={ personid } />
        }
    }

    render() {
        const { person, type } = this.props
        const title = person.get("displayName") ?
            person.get("firstname") + " " + person.get("lastname")
            :
            "AviationNetwork"

        return (
            <DocumentTitle title={ title }>
                <div className="page">
                    <div className="row">
                        <div className="col-xs-12">
                            <Stepper
                                activeStep={ this.state.stepIndex }
                                linear={ false }>
                                <Step>
                                    <StepButton
                                        onClick={ this.step1 }>
                                        Personal Details
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step2 }>
                                        { type === types.PILOT ||
                                            type === types.ENGINEER ?
                                            "License"
                                            : "Visa"
                                        }
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step3 }>
                                        { type === types.FLIGHT_ATTENDANT ?
                                            "Type Flown"
                                            : "Rating"
                                        }
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step4 }>
                                        Language
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step5 }>
                                        Job History
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step6 }>
                                        Documents
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step7 }>
                                        Other
                                    </StepButton>
                                </Step>
                                <Step>
                                    <StepButton
                                        onClick={ this.step8 }>
                                        Overview
                                    </StepButton>
                                </Step>
                            </Stepper>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            { this.getActiveStepComponent() }
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

const mapStateToProps = state => {
    return {
        person: state.profile.person.get("data"),
        type: state.profile.person.get("data").get("type", "Pilot")
    }
}

export default connect(mapStateToProps)(Profile)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/profile.js
 **/